import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { pgCardModule } from '../@pages/components/card/card.module';
import { pgSliderModule } from '../@pages/components/slider/slider.module';
import { WidgetsRoutingModule } from './widgets-routing.module';
import { NumberWidgetComponent } from './number-widget/number-widget.component';
import { SelectFilmComponent } from './select-film/select-film.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { FormsModule } from '@angular/forms';
import { DealFilesGalleryComponent } from './deal-files-gallery/deal-files-gallery.component';
// import { IsotopeModule } from 'ngx-isotope';
import { SharedModule } from '../@pages/components/shared.module';
import { FilmCalculatorComponent } from './film-calculator/film-calculator.component';
import { AddEventModalComponent } from './add-event-modal/add-event-modal.component';
import { pgDatePickerModule } from '../@pages/components/datepicker/datepicker.module';
import { pgTimePickerModule } from '../@pages/components/time-picker/timepicker.module';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { pgSelectModule } from '../@pages/components/select/select.module';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { FilmCheckoutModalComponent } from './film-checkout-modal/film-checkout-modal.component';
import { MergeOfficesModalComponent } from './merge-offices-modal/merge-offices-modal.component';
import { SelectDealComponentComponent } from './select-deal-component/select-deal-component.component';
import { SelectContactComponent } from './select-contact/select-contact.component';
import { EventDetailsModalComponent } from './event-details-modal/event-details-modal.component';
import { PhonePipe } from './_pipes/phone-number.pipe';
import { DealInfoHeaderComponent } from './deal-info-header/deal-info-header.component';
import { ConfirmModalComponent } from './confirm-modal/confirm-modal.component';
import { NgPipesModule } from 'ngx-pipes'
import { LightgalleryModule } from 'lightgallery/angular/13';
import { ExceptionModalComponent } from './exception-modal/exception-modal.component';
import { SearchInputComponent } from './search-input/search-input.component';


@NgModule({
    declarations: [
        NumberWidgetComponent,
        SelectFilmComponent,
        DealFilesGalleryComponent,
        FilmCalculatorComponent,
        AddEventModalComponent,
        FilmCheckoutModalComponent,
        MergeOfficesModalComponent,
        SelectDealComponentComponent,
        SelectContactComponent,
        EventDetailsModalComponent,
        ExceptionModalComponent,
        PhonePipe,
        DealInfoHeaderComponent,
        ConfirmModalComponent,
        SearchInputComponent,
    ],
    imports: [
        LightgalleryModule,
        CommonModule,
        NgPipesModule,
        NgxDatatableModule,
        WidgetsRoutingModule,
        TypeaheadModule.forRoot(),
        FormsModule,
        // IsotopeModule,
        SharedModule,
        pgCardModule,
        pgSelectModule,
        pgSliderModule,
        pgDatePickerModule,
        pgTimePickerModule,
        TimepickerModule.forRoot(),
        ModalModule.forRoot(),
        BsDatepickerModule.forRoot(),
    ],
    exports: [
        NumberWidgetComponent,
        SelectFilmComponent,
        DealFilesGalleryComponent,
        FilmCalculatorComponent,
        AddEventModalComponent,
        FilmCheckoutModalComponent,
        MergeOfficesModalComponent,
        SelectDealComponentComponent,
        SelectContactComponent,
        EventDetailsModalComponent,
        PhonePipe,
        DealInfoHeaderComponent,
        ConfirmModalComponent,
        SearchInputComponent
    ],
    providers: []
})
export class WidgetsModule { }
